<script setup lang="ts">
  import { Illustration } from '@tundr/ds-components';
  import { modalTitleImageClass } from './ModalTitleImage.css';

  defineProps<{
    src: string;
    alt?: string;
  }>();
</script>

<template>
  <Illustration :class="modalTitleImageClass" :src="src" :alt="alt" />
</template>
